import Config from 'config'
import AbstractService from './AbstractService'

export default class AuthService extends AbstractService {
  static login({ username, password, publicdevice }) {
    return this._post({
      subdomain: null,
      url: Config.endpoints.login,
      data: {
        username,
        password,
        publicdevice
      }
    })
  }

  static logout() {
    return this.post(Config.endpoints.logout)
  }

  static requestLoginEmail({ publicdevice, email }) {
    return this.post(Config.endpoints.loginPwdLess, {
      publicdevice,
      email,
      dtw: false
    })
  }

  static requestForgotPwd({ email }) {
    return this.get(
      Config.endpoints.forgotPwd.replace('{0}', encodeURIComponent(email))
    )
  }

  static resetPassword({ password, token }) {
    return this.put({
      url: Config.endpoints.resetPwd,
      data: {
        password,
        token
      }
    })
  }

  static loginPwdLess({ token }) {
    return this.put({
      url: Config.endpoints.loginPwdLess,
      data: {
        token,
        dtw: false
      }
    })
  }

  static refresh(refreshToken) {
    return this.put({
      url: Config.endpoints.refresh,
      data: {
        'refresh-token': refreshToken
      }
    })
  }

  static checkAccountsByEmail({ email }) {
    return this._post({
      subdomain: null,
      url: Config.endpoints.checkAccountsByEmail,
      data: {
        email
      }
    })
  }

  static sendEmailVerificationCode({ email }) {
    return this._post({
      subdomain: null,
      url: Config.endpoints.sendEmailVerificationCode,
      data: {
        email
      }
    })
  }

  static validateEmailVerificationCode({ email, code }) {
    return this._post({
      subdomain: null,
      url: Config.endpoints.validateEmailVerificationCode,
      data: {
        email,
        code
      }
    })
  }

  static confirmSignup(data) {
    return this._post({
      subdomain: null,
      url: Config.endpoints.confirmSignup,
      data
    })
  }

  static acceptInvitation({ invitation_token }) {
    return this._post({
      subdomain: null,
      url: Config.endpoints.acceptInvitation,
      data: {
        invitation_token
      }
    })
  }

  static cancelAllSessions() {
    return this.del(Config.endpoints.cancelSessions)
  }

  static sendInvitations({ invitations }) {
    return this._post({
      subdomain: null,
      url: Config.endpoints.sendInvitations,
      data: {
        invitations: invitations
      }
    }).catch((error) => {
      console.error('Error in POST request:', error)
      throw error
    })
  }

  static getConnections() {
    return this._get({
      subdomain: null,
      url: Config.endpoints.connections
    }).then((response) => response)
  }

  static deleteConnection({ connected_player_id }) {
    return this._del({
      subdomain: null,
      url: `${Config.endpoints.deleteConnection}/${connected_player_id}`
    }).then((response) => response)
  }

  static processConnections() {
    return this._post({
      subdomain: null,
      url: Config.endpoints.processConnections
    })
  }
}
